/* Generated by tools/build_sections.py from brand/sizer.js.
   Edit there, not here. */
(function(){if(window.__efEnergy_sizer)return;window.__efEnergy_sizer=1;
/* EcoFlow Home Energy — the OCEAN 2 sizer and the day simulation.
 *
 * Two controls (battery modules, inverter output) and an hour scrubber drive
 * twenty-two figures on the page. In the prototype they were derived in
 * renderVals; statically they froze at the default state — a sizer whose
 * numbers do not move, which is worse than no sizer.
 *
 * The arithmetic is hbSim (brand/hbsim.js, ported verbatim and unit-tested).
 * The FORMATTING below is lifted from the handoff's renderVals expression for
 * expression, so the two cannot drift. Where the handoff is wrong it is still
 * lifted, not corrected — STATE.md records the two findings in the model, and
 * fixing them is EcoFlow's call, not this file's.
 *
 * Constants come from data/sizer.json via the build, never typed here.
 */
(function () {
  "use strict";

  var root = document.querySelector('[data-hb="hbMods"]');
  if (!root || typeof window.hbSim !== "function") return;

  var cfgEl = document.querySelector("[data-hb-config]");
  var C = {};
  try { C = JSON.parse(cfgEl ? cfgEl.textContent : "{}"); } catch (e) { C = {}; }
  var HB_MM = C.HB_MM, HB_KG = C.HB_KG, HB_INV_KG = C.HB_INV_KG, HB_NARR = C.HB_NARR || [];
  if (!HB_MM || !HB_KG || !HB_INV_KG) return;      // never guess a mass or a height

  var modsEl = document.querySelector('[data-eh="hb-mods"]');
  var hourEl = document.querySelector('[data-eh="hb-hour"]');
  var invBtns = document.querySelectorAll("[data-hbinv]");
  var hourBtns = document.querySelectorAll("[data-hbhour]");

  var mods = modsEl ? +modsEl.value : 4;
  var hour = hourEl ? +hourEl.value : 20;
  var inv = 10;
  (function () {                                   // the pressed inverter chip
    for (var i = 0; i < invBtns.length; i++) {
      if (invBtns[i].getAttribute("aria-pressed") === "true") {
        inv = +invBtns[i].getAttribute("data-hbinv");
        return;
      }
    }
  })();

  function set(name, text) {
    var el = document.querySelector('[data-hb="' + name + '"]');
    if (el) el.textContent = text;
  }

  /* --- lifted from renderVals, expression for expression ----------------- */
  var pad = function (n) { return String(n).padStart(2, "0"); };
  var kw = function (v) { return v > 0.02 ? v.toFixed(2) + " kW" : "—"; };
  var money = function (n) { return "RM " + Math.round(n).toLocaleString("en-MY"); };
  function flow(x) {
    if (x.chg > 0.3) return "Filling the battery";
    if (x.solar >= x.batt && x.solar >= x.grid) return "Running straight off the roof";
    if (x.batt >= x.grid) return "Running on this afternoon’s sun";
    return "Buying from the grid";
  }

  function paint() {
    var hb = window.hbSim(mods, inv);
    var usable = hb.cap * 0.9;
    var night = usable / 18.5;
    var x = hb.hours[hour] || hb.hours[0];

    set("hbMods", String(mods));
    set("hbCap", hb.cap.toFixed(1) + " kWh");
    set("hbUsable", usable.toFixed(1) + " kWh");
    set("hbChgDch", hb.chgMax.toFixed(1) + " kW / " + hb.dchMax.toFixed(1) + " kW");
    set("hbHeight", (mods * HB_MM) + " mm");
    set("hbWeight", (mods * HB_KG + HB_INV_KG).toFixed(1) + " kg");
    set("hbEssentialDays", (usable / 6.5).toFixed(1) + " days");
    set("hbAcHours", (usable / 3.2).toFixed(1) + " hours");
    set("hbNightCover", night >= 1 ? night.toFixed(1) + "× over"
                                   : Math.round(night * 100) + "% of it");
    set("hbCascadeNote", mods >= 12
      ? "Twelve modules is the ceiling on one inverter. Past 60.2kWh you cascade a second — up to five on-grid."
      : "Room for " + (12 - mods) + " more modules later, with no change to the electrical work.");

    set("hbHourTariff", pad(x.h) + ":00 · " + (x.peak ? "Peak tariff window" : "Off-peak"));
    set("hbFlow", flow(x));
    var narr = null;
    for (var i = 0; i < HB_NARR.length; i++) {
      if (x.h <= HB_NARR[i].to) { narr = HB_NARR[i]; break; }
    }
    set("hbNarr", (narr || HB_NARR[HB_NARR.length - 1] || {}).t || "");
    set("hbSelLoad", kw(x.load));
    set("hbSelPv", kw(x.pv));
    set("hbSelBatt", kw(x.batt));
    set("hbSelGrid", kw(x.grid + x.topUp));
    set("hbSelSoc", x.socPct + "%");

    set("hbSelfPct", hb.selfPct + "%");
    set("hbGridKwh", hb.grid.toFixed(1) + " kWh");
    /* TWO BUGS LIVED IN THESE TWO LINES.
     *
     * 1. `hb.saved` is not the battery's saving. hbsim.js says so in its own
     *    comment: it credits the battery with the SOLAR's self-consumption,
     *    and run with zero modules it still reports RM 4.62 a day for a house
     *    that has no battery at all. Published beside a battery that is being
     *    quoted, that attributes the array's value to the battery -- the
     *    exact thing hbsim.js warns about (F2.L8, CPA 1999). The honest field
     *    was already there and simply was not wired up: savedByBattery, this
     *    system against the SAME house with the same solar and no battery.
     *    On the shipped 4-module profile that is RM 4.48/day, not RM 9.10 --
     *    the live page was running 2.03x high.
     *
     * 2. x365 treats every day of the year as a weekday. TNB's own tariff
     *    page is explicit that peak is 14:00-22:00 MONDAY TO FRIDAY and that
     *    Saturday and Sunday are off-peak for all 24 hours, so a year is 261
     *    weekday shapes and 104 weekend ones. The weekend day is the same
     *    simulation with no peak window at all. */
    var weekend = window.hbSim(mods, inv, { peakFrom: 0, peakTo: 0 });
    var year = hb.savedByBattery * 261 + weekend.savedByBattery * 104;
    set("hbSaveDay", "RM " + hb.savedByBattery.toFixed(2));
    set("hbSaveYear", money(year));

    /* The 24 bars: same geometry as the handoff — each segment is its share of
       a bar whose height is the hour's load against a 2.4kW ceiling. */
    Array.prototype.forEach.call(hourBtns, function (b) {
      var h = +b.getAttribute("data-hbhour");
      var y = hb.hours[h];
      if (!y) return;
      var px = Math.max(6, Math.round(y.load / 2.4 * 150));
      var seg = function (v) { return y.load > 0 ? Math.round(v / y.load * px) : 0; };
      var spans = b.querySelectorAll("span");
      if (spans.length >= 4) {
        spans[0].style.height = seg(y.solar) + "px";
        spans[1].style.height = seg(y.batt) + "px";
        spans[2].style.height = seg(y.grid) + "px";
        spans[3].style.background = y.peak ? "var(--ef-red-600)" : "transparent";
      }
      b.style.opacity = h === hour ? "1" : "0.45";
      b.setAttribute("aria-pressed", h === hour ? "true" : "false");
      b.title = pad(h) + ":00 — " + y.load.toFixed(2) + "kW, " + y.socPct + "% charged";
    });

    Array.prototype.forEach.call(invBtns, function (b) {
      var on = +b.getAttribute("data-hbinv") === inv;
      b.setAttribute("aria-pressed", on ? "true" : "false");
      b.style.background = on ? "var(--action-mono-bg)" : "transparent";
      b.style.color = on ? "var(--action-mono-fg)" : "var(--text)";
      b.style.borderColor = on ? "var(--action-mono-bg)" : "var(--border-strong)";
    });
  }

  if (modsEl) modsEl.addEventListener("input", function () { mods = +modsEl.value; paint(); });
  if (hourEl) hourEl.addEventListener("input", function () { hour = +hourEl.value; paint(); });
  Array.prototype.forEach.call(invBtns, function (b) {
    b.addEventListener("click", function () { inv = +b.getAttribute("data-hbinv"); paint(); });
  });
  Array.prototype.forEach.call(hourBtns, function (b) {
    b.addEventListener("click", function () {
      hour = +b.getAttribute("data-hbhour");
      if (hourEl) hourEl.value = hour;
      paint();
    });
  });

  paint();

  window.EcoFlowEnergy = window.EcoFlowEnergy || {};
  window.EcoFlowEnergy.sizer = {
    set: function (m, i, h) { mods = m; inv = i; hour = h; paint(); },
    read: function () { return { mods: mods, inv: inv, hour: hour }; }
  };
})();

})();
